var render, staticRenderFns
import script from "./Skeleton2NavigationMixin.vue?vue&type=script&lang=js&"
export * from "./Skeleton2NavigationMixin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "Skeleton2NavigationMixin.vue"
export default component.exports